import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["step-counter", {'push-left': _ctx.pushLeft}])
  }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.steps.counter', _ctx.stepNumber, _ctx.nbSteps)), 3))
}